import {Chapter} from '../types';

export type ExampleBookConfig = {
  publicUrl: string;
  fileName: string;
  mime: string;
};

export type ChapterPresetRule =
  | {
      type: 'index';
      index: number;
      side: 'left' | 'right' | 'both';
    };

export type ChapterPreset = ChapterPresetRule | null;

const PUBLIC_URL = process.env.PUBLIC_URL || '';

export const EXAMPLE_ONBOARDING = {
  left: {
    publicUrl: `${PUBLIC_URL}/left.epub`,
    fileName: 'left.epub',
    mime: 'application/epub+zip',
  } satisfies ExampleBookConfig,
  right: {
    publicUrl: `${PUBLIC_URL}/right.epub`,
    fileName: 'right.epub',
    mime: 'application/epub+zip',
  } satisfies ExampleBookConfig,
  chapterPreset: {
    type: 'index',
    index: 1,
    side: 'left',
  } as ChapterPreset,
} as const;

export type ExampleOnboardingConfig = typeof EXAMPLE_ONBOARDING;

export type ChapterPresetResult = {
  leftChapters?: Chapter[];
  rightChapters?: Chapter[];
};
